export default __webpack_public_path__ + "static/media/ElevatedBoston.44fc646f.jpg";